export const SPLIT_VIEW_FOOTER_HEIGHT = 64

export const DEFAULT_SPLIT_VIEW_STATE = {
  isTableCollapsed: false,
  resizeContinues: false
}
